'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _ramda = require('ramda');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);

var _RealtorField = require('../Realtor/RealtorContactUs/RealtorField/RealtorField');var _RealtorField2 = _interopRequireDefault(_RealtorField);
var _ = require('../');
var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _SaveSearchLocationForm = require('./SaveSearchLocationForm.scss');var styles = _interopRequireWildcard(_SaveSearchLocationForm);
var _constants = require('../../constants');
var _checkers = require('../../utils/checkers');
var _findAncestor = require('../../helpers/findAncestor');var _findAncestor2 = _interopRequireDefault(_findAncestor);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _getLocalizedData2 = require('../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);
var _stringifySelect = require('../../utils/stringifySelect');var _stringifySelect2 = _interopRequireDefault(_stringifySelect);
var _saveSearch = require('../../../static/icons/saveSearch.svg');var _saveSearch2 = _interopRequireDefault(_saveSearch);
var _UserAuthenticationPageModal = require('../../pages/UserAuthenticationPage/UserAuthenticationPageModal');var _UserAuthenticationPageModal2 = _interopRequireDefault(_UserAuthenticationPageModal);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

SaveSearchLocationForm = function (_Component) {_inherits(SaveSearchLocationForm, _Component);function SaveSearchLocationForm() {var _temp, _this, _ret;_classCallCheck(this, SaveSearchLocationForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      tab: _constants.userAuthenticationTabs.SIGN_IN,
      isTemporaryEmail: false,
      showTemporaryModal: false,
      submitError: null,
      searchName: '',
      authThroughSocialNetwork: false }, _this.

















































    getSubmitButtonText = function (isLoggedIn) {
      var translate = _this.props.translate('saveSearchLocation');

      if (isLoggedIn) {
        return translate('submit')();
      }

      var actionType = _this.state.tab === _constants.userAuthenticationTabs.NEW_ACCOUNT ?
      'createNewAccount' :
      'login';

      return translate(actionType);
    }, _this.


    isLoggedIn = _this.props.isLoggedIn, _this.
    formId = 'save-search-form', _this.

    authThroughSocialNetwork = function (network) {
      _this.setState({ authThroughSocialNetwork: true });
      _this.props.socialNetworkAuthentication(network);
    }, _this.

    forgotPasswordClick = function (evt) {
      evt.preventDefault();
      _this.props.
      close().
      then(function () {return _this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.FORGOT_PASSWORD });});
    }, _this.

    handleSubmit = function (_ref) {var searchName = _ref.searchName,emailField = _ref.email,password = _ref.password,actualEmail = _ref.actualEmail,rest = _objectWithoutProperties(_ref, ['searchName', 'email', 'password', 'actualEmail']);
      if (_this.isLoggedIn) {
        return _this.props.saveSearchData(searchName);
      }var

      showTemporaryModal = _this.state.showTemporaryModal;
      var userEmail = actualEmail || emailField;
      var action = showTemporaryModal ? _this.props.editUserProfile : _this.props.auth;

      var agentParams = rest.is_agent ? rest : {};

      var params = showTemporaryModal ? {
        userToken: _this.props.userToken,
        partialUpdate: {
          email: actualEmail } } : Object.assign({

        email: userEmail, password: password, requestType: _this.state.tab }, agentParams);

      return action(params);
    }, _this.

    resetFormError = function () {return _this.setState({ submitError: null });}, _this.

    toggleOverflow = function (bool) {
      global.window.document.body.classList.toggle('no-overflow', bool);
    }, _this.

    toggleTab = function (tab) {return function (evt) {
        evt.preventDefault();
        _this.setState({ tab: tab, submitError: null });
      };}, _this.

    temporaryUserCheck = function (_ref2) {var target = _ref2.target;
      if ((0, _checkers.isTemporaryEmail)(target.value)) {
        _this.setState({ isTemporaryEmail: true });
      }
    }, _this.

    storeSearchName = function (_ref3) {var target = _ref3.target;return _this.setState({ searchName: target.value });}, _this.

    openTempMailModal = function () {
      _this.modalPortal = (0, _findAncestor2.default)(_this.formElement, 'ReactModalPortal');
      _this.modalPortal.style.display = 'none';
      _this.setState({ showTemporaryModal: true, submitError: null });
    }, _this.

    formatHighlightValue = function (label, value) {var
      translate = _this.props.translate;
      switch (label) {
        case 'address':return value;
        case 'optionType':return translate('header', value);
        case 'propertyTypes':return value instanceof Array ? value.map(function (item) {return translate('propertyTypes', item);}).join(', ') : value;
        case 'price':{var
            minPrice = value.minPrice,maxPrice = value.maxPrice;
            var separator = minPrice && maxPrice ? ' - ' : '';
            var prefix = !!minPrice ? 'from' : 'to';
            var finalPrefix = minPrice && maxPrice ? '' : _this.props.translate('price', prefix) + ' ';

            return minPrice || maxPrice ? '' + finalPrefix + (value.minPrice || '') + separator + (value.maxPrice || '') + ' \u20AA' : value;
          }
        case 'rooms':return value instanceof Array ? (0, _stringifySelect2.default)(value) : value;
        default:return value;}

    }, _this.

    renderTabSwitcher = function () {
      if (_this.isLoggedIn) {
        return null;
      }

      switch (_this.state.tab) {
        case _constants.userAuthenticationTabs.NEW_ACCOUNT:{
            return (
              _react2.default.createElement('div', { className: styles.tabSwitcher },
                _react2.default.createElement('span', null),

                _react2.default.createElement('a', { href: '', onClick: _this.toggleTab(_constants.userAuthenticationTabs.SIGN_IN) },
                  _this.props.translate('saveSearchLocation', 'alreadyHaveAccount')),


                _react2.default.createElement('span', null)));


          }
        case _constants.userAuthenticationTabs.SIGN_IN:
        default:{
            return (
              _react2.default.createElement('div', { className: styles.tabSwitcher },
                _react2.default.createElement('a', { href: '', onClick: _this.toggleTab(_constants.userAuthenticationTabs.NEW_ACCOUNT) },
                  _this.props.translate('saveSearchLocation', 'newAccount'))));



          }}

    }, _this.

    renderTermsAndCondition = function () {
      if (_this.isLoggedIn || !_this.isLoggedIn && _this.state.tab !== _constants.userAuthenticationTabs.NEW_ACCOUNT) {
        return null;
      }
      var translate = _this.props.translate('saveSearchLocation');
      var delimiter = translate('delimiter')() &&
      _react2.default.createElement('span', { className: !translate('delimiter')() ? styles.delimiter : '' },
        translate('delimiter'));



      return (
        _react2.default.createElement('div', { className: styles.termsAndCondition },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'term-of-use',
            id: 'term-of-use',
            type: 'checkbox',
            component: function component(_ref4) {var _cx;var id = _ref4.id,input = _ref4.input,meta = _ref4.meta;return (
                _react2.default.createElement(_.OMCheckbox, {
                  id: id,
                  field: input,
                  className: (0, _classnames2.default)(styles.checkbox, (_cx = {}, _cx[styles.invalid] = meta.error && !meta.active && meta.submitFailed, _cx)) }));},


            validate: [_reduxFormValidators.required] }),


          _react2.default.createElement('p', { className: styles.checkboxLabel },

            _react2.default.createElement('span', null, translate('confirm')), ' ', _react2.default.createElement('a', { href: (0, _appendLocale2.default)(_this.props.locale, '/terms'), target: '_blank', rel: 'noopener noreferrer' },
              translate('termsOfUse')), ' ',
            delimiter, ' ', _react2.default.createElement('a', { href: (0, _appendLocale2.default)(_this.props.locale, '/privacy'), target: '_blank', rel: 'noopener noreferrer' },
              translate('privacy')))));




    }, _this.

    renderIsAgentCheckbox = function () {
      if (_this.isLoggedIn || !_this.isLoggedIn && _this.state.tab !== _constants.userAuthenticationTabs.NEW_ACCOUNT) {
        return null;
      }
      var translate = _this.props.translate('saveSearchLocation');

      return (
        _react2.default.createElement('div', { className: styles.termsAndCondition },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'is_agent',
            id: 'is_agent',
            type: 'checkbox',
            component: function component(_ref5) {var _cx2;var id = _ref5.id,input = _ref5.input,meta = _ref5.meta;return (
                _react2.default.createElement(_.OMCheckbox, {
                  id: id,
                  field: input,
                  className: (0, _classnames2.default)(styles.checkbox, (_cx2 = {}, _cx2[styles.invalid] = meta.error && !meta.active && meta.submitFailed, _cx2)) }));} }),




          _react2.default.createElement('p', { className: styles.checkboxLabel },
            translate('professionalConfirmation'))));



    }, _this.

    renderAgentDetails = function () {
      if (_this.state.tab !== _constants.userAuthenticationTabs.NEW_ACCOUNT || !_this.props.fields.is_agent) {return null;}
      var translate = _this.props.translate('saveSearchLocation');

      return (
        _react2.default.createElement('div', { className: styles.agentDataRow },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'license_number',
            id: 'license_number',
            type: 'text',
            htmlFor: 'license_number',
            component: _RealtorField2.default,
            placeholder: translate('licenseNumber')(),
            validate: [_reduxFormValidators.licenseNumber],
            translate: _this.props.translate,
            translateForError: _this.props.translate('errorFieldMessages'),
            isRtl: _this.props.isRtl,
            isMobile: _this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: _this.resetFormError }),


          _react2.default.createElement(_reduxForm.Field, {
            name: 'company_name',
            id: 'company_name',
            type: 'text',
            htmlFor: 'company_name',
            component: _RealtorField2.default,
            placeholder: translate('companyName')(),
            validate: [_reduxFormValidators.required],
            translate: _this.props.translate,
            translateForError: _this.props.translate('errorFieldMessages'),
            isRtl: _this.props.isRtl,
            isMobile: _this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: _this.resetFormError }),

          _react2.default.createElement('div', null)));


    }, _this.

    renderTopBlock = function () {return (
        _react2.default.createElement('div', { className: styles.topBlock },
          _react2.default.createElement('img', { src: _saveSearch2.default, alt: '' }),
          _react2.default.createElement('div', null,
            _react2.default.createElement('h2', { className: styles.title }, _this.props.translate('saveSearchLocation', 'title')),
            _react2.default.createElement('span', null, _this.props.translate('saveSearchLocation', 'titleDescription')))));}, _this.




    renderHighlightItem = function (label, value) {var _cx3;
      if (!value) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)((_cx3 = {}, _cx3[styles.locationRow] = label === 'address', _cx3)) },
          _react2.default.createElement('p', null, _this.props.translate('saveSearchLocation', label), ': '),
          _react2.default.createElement('p', null, _this.formatHighlightValue(label, value))));


    }, _this.

    renderHighlights = function () {var _this$props =
      _this.props,routeData = _this$props.routeData,locale = _this$props.locale,translate = _this$props.translate;
      var searchData = (0, _get2.default)(routeData, 'locationSearch', {});var _getLocalizedData =
      (0, _getLocalizedData3.default)(searchData, locale, 'en'),result = _getLocalizedData.result;

      var all = translate('search_box', 'searchContainer', 'all');

      var address = (0, _get2.default)(result, 'formatted');
      var price = (0, _get2.default)(routeData, 'params.price') || all;
      var rooms = (0, _get2.default)(routeData, 'params.rooms') || all;
      var propertyTypes = (0, _get2.default)(routeData, 'params.types') || all;
      var optionType = (0, _get2.default)(routeData, 'optionType');

      return (
        _react2.default.createElement('div', { className: styles.highlights },
          _this.renderHighlightItem('address', address),
          _this.renderHighlightItem('optionType', optionType),
          _this.renderHighlightItem('propertyTypes', propertyTypes),
          _this.renderHighlightItem('price', price.minPrice || price.maxPrice ? price : all),
          _this.renderHighlightItem('rooms', rooms)));


    }, _this.

    renderSubmitButton = function (submitting) {return (
        _react2.default.createElement('button', { className: styles.submitButton, type: 'submit' },
          submitting &&
          _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),


          !submitting && _this.getSubmitButtonText()));}, _temp), _possibleConstructorReturn(_this, _ret);}SaveSearchLocationForm.prototype.componentWillMount = function componentWillMount() {if (__CLIENT__) {this.toggleOverflow(true);}this.minLengthValidator = (0, _reduxFormValidators.minLength)(6, 'password');this.maxLengthValidator = (0, _reduxFormValidators.maxLength)(20, 'password');};SaveSearchLocationForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var userAuthenticationError = newProps.userAuthenticationError,submitting = newProps.submitting,isLoggedIn = newProps.isLoggedIn;var userAuthError = this.props.userAuthenticationError; // Auth error
    if (!userAuthError && userAuthenticationError || userAuthError && userAuthenticationError && userAuthError.name !== userAuthenticationError.name) {this.setState({ submitError: userAuthenticationError.name });return;}if (!this.props.isLoggedIn && isLoggedIn) {this.props.saveSearchData(this.state.searchName);} // if (this.props.submitting && !submitting && !userAuthenticationError) {
    //   this.props.clearSubmit();
    //   if (this.state.isTemporaryEmail && !this.state.showTemporaryModal) {
    //     this.openTempMailModal();
    //   } else {
    //     console.log('saveSearchData', this.state.searchName);
    //   }
    // }
  };SaveSearchLocationForm.prototype.componentWillUnmount = function componentWillUnmount() {this.toggleOverflow(false);if (this.modalPortal) {this.modalPortal.style.display = '';}if (this.props.onFormClose) {this.props.onFormClose();}}; // Preserve login state
  SaveSearchLocationForm.prototype.render = function render() {var _this2 = this,_cx4;var submitting = this.props.submitting;return _react2.default.createElement('form', { onSubmit: this.props.handleSubmit(this.handleSubmit), className: (0, _classnames2.default)(styles.saveSearchForm, { rtl: this.props.isRtl }),
        id: this.formId,
        noValidate: true,
        ref: function ref(_ref6) {_this2.formElement = _ref6;},
        autoComplete: false },

      _react2.default.createElement('div', { className: styles.controlRow },
        _react2.default.createElement('i', { className: 'icon-close', onClick: this.props.close })),


      this.renderTopBlock(),

      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputRow, (_cx4 = {}, _cx4[styles.loggedRow] = this.props.isLoggedIn, _cx4)) },
        _react2.default.createElement('label', { htmlFor: 'search-location-name', className: styles.inputContainer },
          _react2.default.createElement('p', { className: styles.description }, this.props.translate('saveSearchLocation', 'description')),

          _react2.default.createElement(_reduxForm.Field, {
            name: 'searchName',
            id: 'search-location-name',
            type: 'text',
            component: _RealtorField2.default,
            placeholder: this.props.translate('saveSearchLocation', 'placeholder')(),
            autoFocus: true,
            validate: [_reduxFormValidators.required],
            translate: this.props.translate,
            translateForError: this.props.translate('errorFieldMessages'),
            isRtl: this.props.isRtl,
            onChange: this.storeSearchName,
            isMobile: this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: this.resetFormError })),



        this.props.isLoggedIn &&
        _react2.default.createElement('label', { htmlFor: 'search-location-email', className: (0, _classnames2.default)(styles.inputContainer, styles.disabled) },
          _react2.default.createElement('p', { className: styles.description }, this.props.translate('saveSearchLocation', 'yourEmail')),

          _react2.default.createElement(_reduxForm.Field, {
            name: 'email',
            id: 'search-location-email',
            type: 'email',
            htmlFor: 'search-location-email',
            component: _RealtorField2.default,
            placeholder: this.props.translate('email')(),
            validate: [_reduxFormValidators.email],
            translate: this.props.translate,
            translateForError: this.props.translate('errorFieldMessages'),
            isRtl: this.props.isRtl,
            onChange: function onChange() {},
            isMobile: this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: this.resetFormError,
            disabled: true })),



        this.renderHighlights()),



      !this.isLoggedIn &&
      // <div className={styles.inputContainer}>
      //   <p className={styles.tabDescription}>{ this.props.translate('saveSearchLocation', `please${this.state.tab}`) }</p>
      //   <div className={styles.registrationBlock}>
      //     <div className={styles.authRow}>
      //       <Field
      //         name="email"
      //         id="email"
      //         type="email"
      //         htmlFor="email"
      //         component={InputField}
      //         placeholder={this.props.translate('email')()}
      //         validate={[email]}
      //         translate={this.props.translate}
      //         translateForError={this.props.translate('errorFieldMessages')}
      //         isRtl={this.props.isRtl}
      //         onChange={this.temporaryUserCheck}
      //         isMobile={this.props.isMobile}
      //         className={styles.saveSearchInputContainer}
      //         onFocus={this.resetFormError}
      //       />
      //       <Field
      //         name="password"
      //         id="password"
      //         type="password"
      //         htmlFor="password"
      //         component={InputField}
      //         placeholder={this.props.translate('password')()}
      //         validate={[this.minLengthValidator, this.maxLengthValidator]}
      //         translate={this.props.translate}
      //         translateForError={this.props.translate('errorFieldMessages')}
      //         isRtl={this.props.isRtl}
      //         isMobile={this.props.isMobile}
      //         className={styles.saveSearchInputContainer}
      //         onFocus={this.resetFormError}
      //       />
      //       { !this.props.isMobile && this.renderSubmitButton(submitting) }
      //     </div>
      //     {this.state.tab !== TABS.NEW_ACCOUNT &&
      //       <div className={styles.forgotPassword}>
      //         <a onClick={this.forgotPasswordClick}>
      //           { this.props.translate('saveSearchLocation', 'forgotPassword') }
      //         </a>
      //       </div>
      //     }
      //     {this.renderAgentDetails()}
      //     <div className={styles.intervalWrapper}>
      //       <hr />
      //       <p>{this.props.translate('saveSearchLocation', 'or')}</p>
      //       <hr />
      //     </div>
      //     <div className={styles.bottomBlock}>
      //       <SocialNetworkAuthentication
      //         translate={this.props.translate('userAuthentication')}
      //         socialNetworkAuthentication={this.authThroughSocialNetwork}
      //         className={styles.social}
      //         isMobile={this.props.isMobile}
      //         clickOnArea
      //       />
      //     </div>
      //   </div>
      //   { this.renderTabSwitcher() }
      // </div>
      _react2.default.createElement(_.Modal, {
          isOpen: !this.isLoggedIn },

        _react2.default.createElement(_UserAuthenticationPageModal2.default, null)),



      this.props.isLoggedIn &&
      _react2.default.createElement('div', { className: styles.buttonRow },
        _react2.default.createElement('button', { className: styles.submitButton, type: 'submit' },
          submitting &&
          _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),

          !submitting && this.getSubmitButtonText(true))),




      this.renderIsAgentCheckbox(),
      this.renderTermsAndCondition(),

      this.props.isMobile && !this.props.isLoggedIn && this.renderSubmitButton(submitting),









      _react2.default.createElement(_reactModal2.default, {
          contentLabel: 'temporary-user',
          isOpen: this.state.showTemporaryModal,
          style: Object.assign({}, _constants.centeredModalStyle, {

            overlay: Object.assign({},
            _constants.centeredModalStyle.overlay, {
              zIndex: 15 }) }),


          shouldCloseOnOverlayClick: false,
          shouldCloseOnEsc: false },

        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.tempUserModalBody, styles.inputContainer, { rtl: this.props.isRtl }) },
          _react2.default.createElement('div', { className: styles.controlRow },
            _react2.default.createElement('i', { className: 'icon-close', onClick: this.props.close })),


          _react2.default.createElement('h2', { className: styles.title },
            this.props.translate('userAuthentication', 'title')),


          _react2.default.createElement('label', { htmlFor: 'actualEmail' },
            this.props.translate('userAuthentication', 'descriptionForTemporaryUser')),


          _react2.default.createElement(_reduxForm.Field, {
            component: _RealtorField2.default,
            name: 'actualEmail',
            id: 'actualEmail',
            type: 'email',
            htmlFor: 'actualEmail',
            placeholder: this.props.translate('email')(),
            formId: this.formId,
            validate: [_reduxFormValidators.email, _reduxFormValidators.noTempMail],
            translate: this.props.translate,
            translateForError: this.props.translate('errorFieldMessages'),
            isRtl: this.props.isRtl,
            isMobile: this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: this.resetFormError }),


          _react2.default.createElement('button', { type: 'submit', form: this.formId, className: styles.submitButton },
            submitting &&
            _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),


            !submitting && this.getSubmitButtonText()),


          (!!this.state.submitError || this.props.isMobile) &&
          _react2.default.createElement('p', { className: styles.formError },
            !!this.state.submitError &&
            this.props.translate('saveSearchLocation', 'errors', this.state.submitError)))));







  };return SaveSearchLocationForm;}(_react.Component);


SaveSearchLocationForm.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  close: _propTypes2.default.func,
  isLoggedIn: _propTypes2.default.bool,
  fields: _propTypes2.default.object,
  socialNetworkAuthentication: _propTypes2.default.func,
  auth: _propTypes2.default.func,
  saveSearchData: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  userAuthenticationError: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  submitting: _propTypes2.default.bool,
  clearSubmit: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  onFormClose: _propTypes2.default.func };

var selector = (0, _reduxForm.formValueSelector)('save-search-form');

var mapStateToProps = function mapStateToProps(state) {return {
    fields: {
      is_agent: selector(state, 'is_agent') } };};exports.default =



(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps),
(0, _reduxForm.reduxForm)({
  form: 'save-search-form' }))(

SaveSearchLocationForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SaveSearchLocationForm/SaveSearchLocationForm.js
// module id = 2899
// module chunks = 0